import { isNull } from 'lodash/fp';
import React from 'react';

import { Icon } from '../../shared/icon/Icon';
import { Home, SortAscending } from '../../shared/icons';
import styles from '../HomeWrapper.module.scss';
import { MenuTileId } from './MenuTile';

export interface Path {
    id: MenuTileId | null;
    label: string;
}

interface NavigationPathProps {
    selectPath: (tileId: MenuTileId | null) => void;
    getPath: (tileId: MenuTileId) => Path[];
    selectedTile: MenuTileId | null;
}

export const NavigationPath: React.FC<NavigationPathProps> = ({ getPath, selectedTile, selectPath }) => {

    if (isNull(selectedTile)) {
        return null;
    }

    const adminPath = getPath(selectedTile);
    return (
        <div className={styles.navigationWrapper}>
            <div className={styles.iconNavigationWrapper}>
                <button className={styles.rotatedNavigationButton} onClick={() => selectPath(adminPath[adminPath.length - 2].id)}><Icon icon={SortAscending} fontSize={32} /></button>
                <button className={styles.navigationButton} onClick={() => selectPath(null)}><Icon icon={Home} fontSize={32} /></button>
            </div>
            <div className={styles.pathContent}>
                {adminPath.map(({ label, id }, index) => (
                    <button key={id} className={styles.adminPath} onClick={() => selectPath(id)}>
                        <div className={styles.adminPathLabel}>{label}</div>
                        {index !== adminPath.length - 1 && <div className={styles.adminPathSpacer}>/</div>}
                    </button>
                ))}
            </div>
        </div>
    );
};
